import { ADD_FEATURES, REMOVE_FEATURES } from '@instructure/quiz-common';
export function addFeatures(featuresList) {
  return {
    type: ADD_FEATURES,
    payload: featuresList
  };
}
export function removeFeatures(featuresToRemove) {
  return {
    type: REMOVE_FEATURES,
    payload: featuresToRemove
  };
}